import { useEffect, useState } from "react";
import DataTable from "../../../utils/components/DataTable";
import { Translate } from "react-localize-redux";
import Checkbox from "../../../utils/components/Checkbox";

const columns = [
  {
    name: <Translate id="form_templates.authorization.groups" />,
    cell: (row) => (
      <>
        <strong className="me-1">{row.name}</strong> ({row.company_name})
      </>
    ),
    width: "30%",
  },
  {
    name: <Translate id="form_templates.authorization.no_access" />,
    selector: (row) => row.is_access,
    cell: (row) => <Checkbox checked={row.is_access} disabled size="lg" />,
    center: true,
  },
  {
    name: <Translate id="form_templates.authorization.view_all_forms" />,
    selector: (row) => row.is_view_all,
    cell: (row) => <Checkbox checked={row.is_view_all} disabled size="lg" />,
    center: true,
  },
  {
    name: <Translate id="form_templates.authorization.view_received" />,
    selector: (row) => row.is_view_received,
    cell: (row) => <Checkbox checked={row.is_view_received} disabled size="lg" />,
    center: true,
  },
  {
    name: <Translate id="form_templates.authorization.create" />,
    selector: (row) => row.is_create,
    cell: (row) => <Checkbox checked={row.is_create} disabled size="lg" />,
    center: true,
  },
];

const AuthorizationDetail = ({ groups, formAuthorization }) => {
  const [authorizations, setAuthorizations] = useState([]);

  useEffect(() => {
    const newAuthorizations = groups.map((group) => {
      const authorization = formAuthorization.find(
        (auth) => auth.group_id === group.id
      );

      return { ...group, ...authorization };
    });

    setAuthorizations(newAuthorizations);
  }, [groups, formAuthorization]);

  return (
    <div className="AuthorizationPage py-5">
      <DataTable data={authorizations} columns={columns} />
    </div>
  );
};

export default AuthorizationDetail;
